import { render, staticRenderFns } from "./CheckoutPayments.vue?vue&type=template&id=794b011e&"
import script from "./CheckoutPayments.vue?vue&type=script&lang=js&"
export * from "./CheckoutPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports